import {
    lazyGetAttachment,
    lazyRefreshThumbnailImageUrl,
    lazyShouldShowImageView,
} from 'owa-attachment-model-store';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import { ImageGalleryItem } from 'owa-sxsdata';
import { trace } from 'owa-trace';

export default async function createImageGalleryForNewSxS(
    attachmentWellViewState: AttachmentWellViewState,
    useDocViewAttachments: boolean = false
): Promise<ImageGalleryItem[]> {
    const imageGallery: ImageGalleryItem[] = [];
    const getAttachment = await lazyGetAttachment.import();
    const refreshThumbnailImageUrl = await lazyRefreshThumbnailImageUrl.import();
    const shouldShowImageView = useDocViewAttachments
        ? await lazyShouldShowImageView.import()
        : null;

    const attachments = useDocViewAttachments
        ? attachmentWellViewState.docViewAttachments
        : attachmentWellViewState.imageViewAttachments;
    for (let i = 0; i < attachments.length; i++) {
        const attachmentViewState = attachments[i];
        const attachmentModel = getAttachment(attachmentViewState.attachmentId);

        if (useDocViewAttachments && !shouldShowImageView(attachmentModel.model)) {
            continue;
        }

        try {
            await refreshThumbnailImageUrl(
                attachmentViewState.attachmentId,
                attachmentWellViewState.isReadOnly
            );
        } catch (error) {
            trace.warn(
                `Unable to refresh thumbnail image for ${attachmentViewState.attachmentId}. Got error ${error}`
            );
        }

        const imageGalleryItem: ImageGalleryItem = {
            downloadUrl: attachmentModel.download.url,
            id: attachmentViewState.attachmentId,
            previewUrl: attachmentModel.previewImage.url,
            thumbnailUrl: attachmentModel.thumbnailImage.url,
        };
        imageGallery.push(imageGalleryItem);
    }

    return imageGallery;
}
